// (A) 중립 Popover API — antd 미접촉. (B) PlainPopover(Radix) 에 위임.
import type { CSSProperties, ReactNode } from 'react'
import { PlainPopover } from '../_impl/PlainPopover'

export type OmwPopoverTrigger = 'click' | 'hover' | 'focus'

export type OmwPopoverPlacement =
  | 'top'
  | 'topLeft'
  | 'topRight'
  | 'bottom'
  | 'bottomLeft'
  | 'bottomRight'
  | 'left'
  | 'right'

export interface OmwPopoverProps {
  content: ReactNode
  trigger?: OmwPopoverTrigger
  open?: boolean
  onOpenChange?: (open: boolean) => void
  placement?: OmwPopoverPlacement
  getPopupContainer?: (trigger: HTMLElement) => HTMLElement
  /** 실측: styles.body(패딩) → 중립 bodyStyle 로 흡수. */
  bodyStyle?: CSSProperties
  /** 팝업 루트 스타일(antd styles.root — 실측: calendar 이벤트 상세 width). */
  rootStyle?: CSSProperties
  /** 화살표 표시 여부(실측: calendar recurrence dropdown 은 false). */
  arrow?: boolean
  className?: string
  children?: ReactNode
}

export function OmwPopover(props: OmwPopoverProps) {
  return <PlainPopover {...props} />
}
